import cn from "classnames"
import React from "react"

import { useFilterContext } from "~/components/FilterWrapper/FilterWrapper"

import styles from "./index.module.css"

export const FilterPreloaderWrapper: React.FC<{ className?: string }> = ({
  children,
  className,
}) => {
  const { isLoading } = useFilterContext()

  return (
    <div className={cn(className, styles.Wrapper, { [styles.isLoading]: isLoading })}>
      {children}
    </div>
  )
}
